import { render, staticRenderFns } from "./addcombination.vue?vue&type=template&id=564c5108&"
import script from "./addcombination.vue?vue&type=script&lang=js&"
export * from "./addcombination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports